import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { AddressJourney } from "@/features/individuals/components/address-journey"
import { describing } from "@/lib/subject"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/edit/"
)({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      individualQueries.detail(params.individualId)
    )
    await context.queryClient.ensureQueryData(
      individualQueries.addresses(params.individualId)
    )
  },
  component: AddAddressPage,
})

function AddAddressPage() {
  const { individualId } = Route.useParams()
  const navigate = useNavigate()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <AddressJourney
      individualId={individualId}
      subject={describing(individual.firstName)}
      onFinished={() =>
        navigate({
          from: "/$organisation",
          to: "/$organisation/individuals/$individualId/addresses",
          params: { individualId },
        })
      }
    />
  )
}
